export default __webpack_public_path__ + "static/media/cross.68dd2620.webp";